import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef, memo } from "react";
import { Box } from "./Box";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system";
export const aspectRatioClasses = {
    root: "MinervaAspectRatio-root",
};
export const aspectRatioVariants = [
    "auto",
    "1",
    "4/3",
    "16/9",
    "21/9",
    "1/2",
    "3/4",
    "3/1",
    "2",
];
export const AspectRatio = memo(forwardRef((props, ref) => {
    const { variant = "16/9", className, sx, ...rest } = useDefaultProps({ component: "AspectRatio", props });
    return (_jsx(Box, { ref: ref, className: className, sx: mergeSx({
            position: "relative",
            overflow: "hidden",
            aspectRatio: variant,
            lineHeight: 0,
        }, sx), ...rest }));
}));
//# sourceMappingURL=AspectRatio.js.map